import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';

const historySection = document.querySelectorAll('.history');

if (historySection) {
    Swiper.use([Autoplay, EffectFade, Navigation, Pagination]);

    const handleGalleries = (mainGallery, i, prevArrow, nextArrow) => {
        mainGallery.classList.add(`history__content--${i}`);
        prevArrow.classList.add(`history__arrow--prev--${i}`);
        nextArrow.classList.add(`history__arrow--next--${i}`);

        const setBullets = (bullets) => {
            bullets.forEach(item => {
                item.addEventListener('click', event => {
                    const { currentTarget } = event;
                    const idx = parseInt(currentTarget.getAttribute('data-index'));
                    mainGallerySwiper.slideTo(idx);
                })
            })
        }

        const mainGallerySwiper = new Swiper(`.history__content--${i}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            autoplay: false,
            loop: true,
            fadeEffect: {
                crossFade: true,
            },
            pagination: {
                el: historySection[i].querySelector('.history__pagination'),
                type: 'custom',
                touchRatio: 1,
                renderCustom: function (swiper, current, total) {
                    const { innerWidth } = window;
                    let visibleBullets = 3;

                    if (innerWidth > 768) visibleBullets = 8;

                    const historyItems = document.querySelectorAll('.history__single-item:not(.swiper-slide-duplicate)');
                    
                    let startIndex = current - 1;
                    let maxIndex = startIndex + visibleBullets;
                    if (maxIndex > (historyItems.length - 1)) {
                        startIndex = (historyItems.length - 1 - visibleBullets)
                        maxIndex = (historyItems.length - 1)
                    }

                    let bulletsContent = ``;
                    for (let i = startIndex; i <= maxIndex; i++) {
                        const currHistoryItem = historyItems[i];
                        const yearText = currHistoryItem.getAttribute('data-year');
                        const activeClass = ((current - 1) === i) ? 'active' : '';

                        bulletsContent += `<div class="history__single-year ${activeClass}" data-index="${i + 1}"><p class="typo-19 history__single-year-text color-gray-60 f-700">
                            ${yearText}
                        </p></div>`;
                    }

                    return bulletsContent;
                },
            },
            breakpoints: {
                0: {
                    pagination: {
                        dynamicMainBullets: 4,
                    },
                    allowTouchMove: true,
                },
                768: {
                    pagination: {
                        dynamicMainBullets: 8,
                    },
                },
                992: {
                    pagination: {
                        dynamicMainBullets: 8,
                    },
                    allowTouchMove: false,
                },
            },
            navigation: {
                nextEl: nextArrow,
                prevEl: prevArrow
            },
            //allowTouchMove: false,
            slideActiveClass: 'active',
            on: {
                afterInit: function(swiper) {
                    const parent = mainGallery.closest('.history');
                    const bullets = parent.querySelectorAll('.history__single-year');
                    setBullets(bullets);
                }
            }
        });

        mainGallerySwiper.on('paginationRender', (swiper) => {
            const parent = mainGallery.closest('.history');
            const bullets = parent.querySelectorAll('.history__single-year');
            setBullets(bullets);
        })
    };

    historySection.forEach((section, i) => {
        const contentGallery = section.querySelector('.history__content');
        const prevArrow = section.querySelector('.history__arrow--prev');
        const nextArrow = section.querySelector('.history__arrow--next');

        handleGalleries(contentGallery, i, prevArrow, nextArrow);
    });
}
